import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Dialogs } from './views/Dialogs';
import { Background } from './components/Background';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<Dialogs />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Dialogs)
	.build();

export default Layout;
